import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {QuestionExecution} from '../../../data/models/execution/question-execution';
import {QUESTION_TYPES} from '../../../../constants/questionTypes';
import {AnswerOptionExecution, AnswerTextExecution} from '../../../data/models/execution/answer-execution';
import {AnswerExecution} from '../answer-execution';

@Component({
  selector: 'app-question-execution',
  templateUrl: './question-execution.component.html',
  styleUrls: ['./question-execution.component.css']
})
export class QuestionExecutionComponent implements OnInit, AfterViewInit, OnChanges {

  readonly QUESTION_TYPES = QUESTION_TYPES;

  @Input() executionId!: number;
  @Input() number!: number;
  @Input() question!: QuestionExecution;
  @Input() allQuestionsRequired = true;

  @Output() changeQuestion = new EventEmitter<QuestionExecution>();

  @ViewChild('answer') answer!: AnswerExecution;

  constructor() {
  }

  ngOnInit(): void {
    this.updateAnsweredState();
  }

  ngAfterViewInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.question && this.question) {
      this.updateAnsweredState();
    }
  }

  onAnswerOptionsChange(options: AnswerOptionExecution[]): void {
    this.question.options = options;
    this.updateAnsweredState();
    this.changeQuestion.emit(this.question);
  }

  onAnswerTextChange(text: AnswerTextExecution): void {
    this.question.answer = text;
    this.updateAnsweredState();
    this.changeQuestion.emit(this.question);
  }

  submitQuestion(): Promise<void> {
    if (!this.allQuestionsRequired && !this.hasProvidedAnswer()) {
      return Promise.resolve();
    }
    return this.answer.submitAnswer();
  }

  private updateAnsweredState(): void {
    switch (this.question.type.techId) {
      case QUESTION_TYPES.SINGLE_ANSWER: {
        const selectedCount = this.question.options?.filter(option => this.normalizeSelected(option.selected)).length || 0;
        this.question.answered = selectedCount >= 1;
        break;
      }
      case QUESTION_TYPES.MULTIPLE_ANSWER: {
        const selectedCount = this.question.options?.filter(option => this.normalizeSelected(option.selected)).length || 0;
        const minRequired = this.question.minAnswers != null ? this.question.minAnswers : 1;
        this.question.answered = selectedCount >= minRequired;
        break;
      }
      case QUESTION_TYPES.TEXT_ANSWER: {
        const text = this.question.answer?.text || '';
        this.question.answered = text.trim().length > 0;
        break;
      }
      default:
        this.question.answered = false;
    }
  }

  private hasProvidedAnswer(): boolean {
    switch (this.question.type.techId) {
      case QUESTION_TYPES.SINGLE_ANSWER:
        return (this.question.options || []).some(option => this.normalizeSelected(option.selected));
      case QUESTION_TYPES.MULTIPLE_ANSWER:
        return (this.question.options || []).some(option => this.normalizeSelected(option.selected));
      case QUESTION_TYPES.TEXT_ANSWER: {
        const text = this.question.answer?.text || '';
        return text.trim().length > 0;
      }
    }
    return false;
  }

  private normalizeSelected(selected: AnswerOptionExecution['selected']): boolean {
    if (typeof selected === 'string') {
      return selected.toLowerCase() === 'true';
    }
    return !!selected;
  }

}
